// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9":"ForgotPassword","94":"Login","130":"TermsAndCondition","449":"SuccessLinkPage","715":"SignUp","737":"Welcome","818":"ForgotPasswordSuccess"}[chunkId] + "." + {"9":"8ecd0b74","94":"c8177a12","130":"65ce23ba","449":"03ccfb1f","715":"fc625948","737":"dc5312a7","818":"931c1122"}[chunkId] + ".chunk.css";
};